const MAX_TILT_DEG = 28
const clamp = (value, min, max) => Math.max(min, Math.min(max, value))
function glareBackground(rotationX, rotationY) {
  const normX = clamp(rotationX / MAX_TILT_DEG, -1, 1)
  const normY = clamp(rotationY / MAX_TILT_DEG, -1, 1)
  const x = clamp(0.5 - normY * 0.35, 0, 1) * 100
  const y = clamp(0.5 - normX * 0.35, 0, 1) * 100
  return [
    `radial-gradient(circle 50% at ${x}% ${y}%, rgba(255,255,255,0.18) 0%, rgba(255,255,255,0.06) 25%, rgba(255,255,255,0.02) 50%, transparent 100%)`,
    `radial-gradient(circle 40% at ${x}% ${y}%, rgba(255,255,255,0.08) 0%, transparent 80%)`,
  ].join(', ')
}
export { MAX_TILT_DEG, glareBackground }
